import styled from 'styled-components';

const SeekBarStyled = styled.div`
  position: relative;
  z-index: 2;
`;

export default SeekBarStyled;
